import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

   

// Async thunk for saving a resource
export const saveBookmark = createAsyncThunk(
    "bookmark/saveBookmark",
    async ({ resource_id }, { rejectWithValue }) => {
      try {
        const userId = localStorage.getItem("userId");
        const response = await axios.post("https://api.recdbase.org/bookmark/create", { resource_id, userId });
        console.log(response.data);
        
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );
  

const bookmarkSlice = createSlice({
  name: "bookmark",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
  },
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveBookmark.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveBookmark.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(saveBookmark.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to save resource";
      });
  },
});

export const { reset } = bookmarkSlice.actions;
export default bookmarkSlice.reducer;
